import { axios } from './config'

export function getLatestSystemMessage() {
  return axios.get('/systemMessage/latest', {}, false)
}

export function listSystemMessage(params) {
  return axios.get('/systemMessage/admin/list', params || {}, false)
}

export function getSystemMessage(id) {
  return axios.get('/systemMessage/admin/info/' + id, {}, false)
}

export function saveSystemMessage(params) {
  return axios.post('/systemMessage/admin/save', params || {}, false)
}

export function updateSystemMessage(params) {
  return axios.post('/systemMessage/admin/update', params || {}, false)
}

export function publishSystemMessage(id) {
  return axios.post('/systemMessage/admin/publish/' + id, {}, false)
}

export function unpublishSystemMessage(id) {
  return axios.post('/systemMessage/admin/unpublish/' + id, {}, false)
}

export function deleteSystemMessage(id) {
  return axios.post('/systemMessage/admin/delete/' + id, {}, false)
}
